import { ICONS as ICONS_ENUM } from 'Components/utils/icon/icons';

const MEDIA_TYPES = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  VIDEOS360: 'videos360',
  STREETVIEWS: 'streetViews',
  FLOORPLAN: 'floorPlans',
};

const ORDERED_MEDIAS = [
  MEDIA_TYPES.PHOTOS,
  MEDIA_TYPES.VIDEOS,
  MEDIA_TYPES.VIDEOS360,
  MEDIA_TYPES.FLOORPLAN,
  MEDIA_TYPES.STREETVIEWS,
];

const ORDERED_MEDIAS_LAUNCHER = [MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.PHOTOS];

const ICONS = {
  [MEDIA_TYPES.PHOTOS]: ICONS_ENUM.MEDIA_PICTURE,
  [MEDIA_TYPES.VIDEOS]: ICONS_ENUM.MEDIA_VIDEO,
  [MEDIA_TYPES.VIDEOS360]: ICONS_ENUM.MEDIA_360_VIDEO,
  [MEDIA_TYPES.STREETVIEWS]: ICONS_ENUM.STREET_VIEWS_360,
  [MEDIA_TYPES.FLOORPLAN]: ICONS_ENUM.FLOOR_PLAN,
};

const MEDIA_TYPES_NAMES = {
  [MEDIA_TYPES.FLOORPLAN]: 'media_room_plan',
  [MEDIA_TYPES.PHOTOS]: 'media_photos',
  [MEDIA_TYPES.STREETVIEWS]: 'media_streetviews',
  [MEDIA_TYPES.VIDEOS]: 'media_videos',
  [MEDIA_TYPES.VIDEOS360]: 'media_360_view',
};

export { ICONS, MEDIA_TYPES, MEDIA_TYPES_NAMES, ORDERED_MEDIAS, ORDERED_MEDIAS_LAUNCHER };
